import { $api } from "@/services/api";
import store from "@/store";
const state = {
  totalPrApproval: {
    all: 0,
    inProcess: 0,
    history: 0,
  },
};

const getters = {
  totalPrApproval: (state) => state.totalPrApproval,
};

const mutations = {
  async setInProcessPrApproval(state, total) {
    state.totalPrApproval.inProcess = total;
  },
};

const actions = {
  async getTotalPrApproval({ commit }) {
    const prApprovalItemRes = await $api.v_pr_approval_items.get({
      aduser: store.getters.user.userName,
      status: "Waiting",
      is_active: true,
    });
    if (
      prApprovalItemRes &&
      prApprovalItemRes.total
    ) {
      commit("setInProcessPrApproval", prApprovalItemRes.total);
    } else {
      commit("setInProcessPrApproval", 0);
    }
  },
};

export default { state, getters, mutations, actions };
